import { ChakraBox } from '@equip.health/ui';

import Header from '~/components/common/Header';
import { PAGE_LAYOUT, PAGE_TOP_PADDING } from '~/lib/constants';

import ReportsList from './ReportsList';

const Analytics = () => (
  <ChakraBox
    paddingRight={PAGE_LAYOUT.rightSpacing}
    paddingTop={PAGE_TOP_PADDING}
  >
    <Header title="Analytics" />
    <ReportsList />
  </ChakraBox>
);

export default Analytics;
